/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from "react";
import {
  Title,
  GoBack,
  Message,
  TextArea,
  InputField,
  ActionButton,
  MyButton,
} from "../../component/Component";
import { FOLDERS } from "../../../doseeData/utils/Utils";
import { codeOk, errorMessage } from "../../../../middlewares/index";
import { useBlogContext } from "../../../../context/blog/BlogContext";
import { getOneBlog } from "../../../../middlewares/sysNavigation/SysNavigation";
import { defaultImage } from "../../../../middlewares/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../../../middlewares/libraries/imageKit/ImageKitLibrary";
import GenerateDescription from "../../../doseeData/utils/GenerateDescription";
import {
  FiFileText,
  FiUser,
  FiHash,
  FiInfo,
  FiUpload,
  FiImage,
} from "react-icons/fi";
import { FaHandSparkles } from "react-icons/fa";

const Edit = () => {
  const { blog, fetchOneBlog, updateBlog, updateBlogState } = useBlogContext();

  const [localBlog, setLocalBlog] = useState(getOneBlog());

  const blog_id = localBlog.blog_id;
  const [error, setError] = useState(false);
  const [status, setStatus] = useState(0);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [thumbnail, setThumbnail] = useState(localBlog.thumbnail);
  const [thumbnailId, setThumbnailId] = useState(localBlog.image_cdn_id);
  const [title, setTitle] = useState(localBlog.title);
  const [description, setDescription] = useState(localBlog.description);
  const [author, setAuthor] = useState(localBlog.author);
  const localBlogRoutes = "/blog";
  const [showDescriptionModal, setShowDescriptionModal] = useState(null);

  const slugPreview = useMemo(
    () => (title ? String(title).toLowerCase().replace(/\s/g, "_") : "—"),
    [title]
  );

  const descMeta = useMemo(() => {
    const text = description || "";
    const words = text.trim() ? text.trim().split(/\s+/).length : 0;
    const chars = text.length;
    return { words, chars };
  }, [description]);

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
  };

  const responses = (isError, st, msg) => {
    setError(isError);
    setStatus(st);
    setErrorMessage(msg);
  };

  useEffect(() => {
    if (!blog) fetchOneBlog(blog_id);
    else setLocalBlog(blog);
  }, [blog]);

  const updateOneBlogHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      setLoading(false);
      return responses(true, 400, "Image Required");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = {
      title: title,
      author: author,
      reading_time: 10,
      description: description,
      slug: title?.toLowerCase().replace(/\s/g, "_"),
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "...",
    };

    const response = await updateBlog(blog_id, data);
    if (response) {
      if (response.data.status === codeOk) {
        updateBlogState({ blog_id, ...data });
        cleanFields();
        return responses(true, response.data.status, response.data.message);
      } else {
        setLoading(false);
        return responses(true, response.data.status, response.data.message);
      }
    } else {
      setLoading(false);
      return responses(true, 400, errorMessage);
    }
  };

  return (
    <div className="h-full overflow-y-auto rounded-b-xl bg-gradient-to-b from-white to-gray-50 p-4">
      <GoBack props={{ route: localBlogRoutes }} />

      {showDescriptionModal ? (
        <GenerateDescription
          setDescription={setDescription}
          setShowDescriptionModal={setShowDescriptionModal}
        />
      ) : null}

      <form onSubmit={updateOneBlogHandler} className="mx-auto mt-2 max-w-6xl">
        <div className="rounded-3xl border border-gray-200 bg-white shadow-sm">
          <div className="flex flex-col gap-2 px-5 pt-5 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex items-center gap-3">
              <span className="grid h-10 w-10 place-items-center rounded-xl bg-gray-900 text-white">
                <FiFileText className="h-5 w-5" />
              </span>
              <div>
                <Title props={{ title: "Edit Blog Post" }} />
                <div className="mt-1 flex flex-wrap items-center gap-2">
                  <span className="inline-flex items-center gap-1 rounded-full border border-gray-200 bg-gray-100 px-2.5 py-1 text-[11px] font-semibold text-gray-700">
                    <FiHash className="h-3.5 w-3.5" />
                    {slugPreview}
                  </span>
                  <span className="inline-flex items-center gap-1 rounded-full border border-emerald-200 bg-emerald-50 px-2.5 py-1 text-[11px] font-semibold text-emerald-700">
                    <FiInfo className="h-3.5 w-3.5" />
                    {descMeta.words} words · {descMeta.chars} chars
                  </span>
                </div>
              </div>
            </div>
            <div className="text-[11px] text-gray-600">
              <span className="inline-flex items-center gap-1 rounded-md bg-gray-100 px-2 py-[2px] font-semibold">
                <FiImage className="h-3.5 w-3.5" />
                Update the cover, title and content, then save
              </span>
            </div>
          </div>

          <div className="px-5 pb-5">
            <div className="mt-4">
              <Message
                props={{
                  error,
                  success,
                  message,
                  loading,
                  status,
                  onClick: () => {
                    setError(false);
                    setSuccess(false);
                    setErrorMessage("");
                  },
                }}
              />
            </div>

            <div className="mt-4 grid grid-cols-1 gap-6 lg:grid-cols-3">
              <div className="lg:col-span-1">
                <div className="rounded-2xl border border-gray-200 bg-white/90 p-4 shadow-sm">
                  <div className="mb-3 flex items-center justify-between">
                    <div className="text-sm font-semibold text-gray-900">Cover Image</div>
                    <span className="inline-flex items-center gap-1 rounded-md border border-gray-200 bg-gray-100 px-2 py-[2px] text-[10px] font-semibold text-gray-700">
                      <FiUpload className="h-3 w-3" />
                      1600×900
                    </span>
                  </div>
                  <ImageKitUpload
                    thumbnail={thumbnail}
                    thumbnailId={thumbnailId}
                    setThumbnail={setThumbnail}
                    setThumbnailId={setThumbnailId}
                    folder={FOLDERS.TOUR_PACKAGES}
                  />
                </div>
              </div>

              <div className="lg:col-span-2">
                <div className="rounded-2xl border border-gray-200 bg-white/90 p-4 shadow-sm space-y-5">
                  <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                    <div className="space-y-1">
                      <label className="flex items-center justify-between text-[13px] font-semibold text-gray-800">
                        <span className="inline-flex items-center gap-2">
                          <FiFileText className="h-4 w-4 text-gray-600" />
                          Blog Title
                        </span>
                        <span className="rounded-md bg-gray-100 px-2 py-[2px] text-[10px] font-semibold text-gray-700">
                          Required
                        </span>
                      </label>
                      <InputField
                        props={{
                          id: "title",
                          title: "Blog Title",
                          type: "text",
                          value: title ? title : "",
                          onChange: (e) => {
                            setTitle(e.target.value);
                            setError(null);
                            setSuccess(null);
                          },
                        }}
                      />
                      <div className="mt-1 inline-flex items-center gap-2 text-[11px] text-gray-600">
                        <FiHash className="h-3.5 w-3.5" />
                        Slug: <span className="font-mono">{slugPreview}</span>
                      </div>
                    </div>

                    <div className="space-y-1">
                      <label className="flex items-center gap-2 text-[13px] font-semibold text-gray-800">
                        <FiUser className="h-4 w-4 text-gray-600" />
                        Author
                      </label>
                      <InputField
                        props={{
                          id: "author",
                          title: "Author",
                          type: "text",
                          value: author ? author : "",
                          onChange: (e) => {
                            setAuthor(e.target.value);
                            setError(null);
                            setSuccess(null);
                          },
                        }}
                      />
                    </div>
                  </div>

                  <div className="space-y-3">
                    <div className="flex items-center justify-between">
                      <Title props={{ title: "Content" }} />
                      <div className="inline-flex items-center gap-2 text-[11px] text-gray-600">
                        <span className="rounded-md border border-gray-200 bg-gray-100 px-2 py-[2px] font-semibold">
                          {descMeta.words} words · {descMeta.chars} chars
                        </span>
                      </div>
                    </div>

                    <div className="flex items-center gap-2">
                      <MyButton
                        onClick={() => setShowDescriptionModal(true)}
                        className="inline-flex items-center gap-2 rounded-lg bg-gradient-to-br from-blue-700 to-blue-600 px-3 py-2 text-xs font-semibold text-white shadow hover:from-blue-800 hover:to-blue-700"
                      >
                        <FaHandSparkles className="h-4 w-4" />
                        Generate Description
                      </MyButton>
                    </div>

                    <TextArea
                      props={{
                        id: "description",
                        title: "Description",
                        type: "text",
                        value: description ? description : "",
                        onChange: (e) => {
                          setDescription(e.target.value);
                          setError(null);
                          setSuccess(null);
                        },
                      }}
                    />

                    <div className="flex items-center gap-2 text-[11px] text-gray-600">
                      <FiInfo className="h-3.5 w-3.5" />
                      Keep it clear and engaging. You can refine after saving.
                    </div>
                  </div>

                  <div className="pt-2">
                    <ActionButton
                      props={{
                        title: ` Save Changes`,
                        error,
                        success,
                        message,
                        loading,
                        status,
                        onClick: () => {
                          setError(false);
                          setSuccess(false);
                          setErrorMessage("");
                        },
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Edit;
